import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  Box,
  Grid,
  TextField,
  Typography,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from '@mui/material'

import Services from '../../../services/'
import { IQuestion, IQuestionResponse } from '../../../interfaces/static.interface'

const styles = {
  questionsContainer: {
    flexGrow: 1,
    mt: '2rem',
    fontSize: '1.25rem',
  },

  radioButtonGrid: {
    mt: '1.25',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '0.75rem',
  },
}

const Header = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '1.75rem',
}))

const EmployeeIExitInterviewForm = () => {
  const navigate = useNavigate()
  const { slug } = useParams()

  const [questions, setQuestions] = useState<IQuestion[]>([])
  const [answers, setAnswers] = useState<any>()
  const [emptyFieldError, setEmptyFieldError] = useState<boolean>(false)
  const [minFieldError, setMinFieldError] = useState<boolean>(false)
  const [isSubmit, setIsSubmit] = useState<boolean>(false)

  useEffect(() => {
    const getQuestions = async () => {
      const {
        data: { items },
      }: IQuestionResponse = await Services.api.common.fetchQuestions()

      setQuestions(items)
    }

    getQuestions()
  }, [])

  useEffect(() => {
    if (questions) {
      questions.map((e) => {
        onHandleChange(e.slug, '')
      })
    }
  }, [questions])

  const onHandleChange = (identifier: string, value: string) => {
    setAnswers((prev: any) => {
      return {
        ...prev,
        [identifier]: value,
      }
    })
  }

  const onHandleSubmitExitInterview = () => {
    setIsSubmit(true)

    Object.entries(answers).map(([k, v]: any) => {
      if (v === '') {
        setEmptyFieldError(true)
      } else {
        if (v.length < 10) {
          setMinFieldError(true)
        }
      }
    })
  }

  useEffect(() => {
    if (isSubmit) {
      if (emptyFieldError) {
        Services.toast('error', 'Please fill up all questions.')

        setEmptyFieldError(false)
        setIsSubmit(false)
      }

      if (minFieldError) {
        Services.toast('error', 'Please fill up the question with minimum 10 characters.')

        setMinFieldError(false)
        setIsSubmit(false)
      }

      if (!emptyFieldError && !minFieldError) {
        onSaveAnswers()
      }
    }
  }, [emptyFieldError, minFieldError, isSubmit])

  const onSaveAnswers = async () => {
    if (!slug) return

    const payload = { slug, attributes: JSON.stringify(answers) }
    const { success } = await Services.api.employee.register(payload)
    if (success) {
      const { data } = await Services.api.employee.generateOTP({ slug })
      if (data) {
        setIsSubmit(false)
        navigate(`/employee/${slug}/otp`)
      }
    }
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Header>Online HR Clearance Exit Interview</Header>

      <Box sx={styles.questionsContainer}>
        <Grid container spacing={2}>
          {questions.length > 0 &&
            questions.map((question: IQuestion) => (
              <Grid key={question.slug} item xs={12} sx={{ mb: 2 }}>
                <Typography>{question.label}</Typography>

                {question.answers.length === 0 ? (
                  <TextField
                    fullWidth
                    sx={{ mt: '0.75rem' }}
                    label='Your Answer Here'
                    multiline
                    rows={3}
                    inputProps={{ minLength: 10 }}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      onHandleChange(question.slug, e.target.value)
                    }
                  />
                ) : (
                  <FormControl fullWidth sx={{ mt: '0.75rem' }}>
                    <InputLabel id={question.label}>Select</InputLabel>
                    <Select
                      labelId={question.label}
                      id={question.label}
                      value={answers[question.slug] || ''}
                      label='Select'
                      onChange={(e: SelectChangeEvent) =>
                        onHandleChange(question.slug, e.target.value)
                      }
                    >
                      {question.answers.map((answer: string) => (
                        <MenuItem key={answer} value={answer}>
                          {answer}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Grid>
            ))}
        </Grid>

        <Grid container spacing={2} sx={{ mt: '4rem' }}>
          <Grid item sm={6} xs={12}>
            <Button
              fullWidth
              sx={{ p: 2 }}
              variant='contained'
              size='large'
              disableElevation
              onClick={onHandleSubmitExitInterview}
            >
              Proceed
            </Button>
          </Grid>

          <Grid item sm={6} xs={12}>
            <Button
              fullWidth
              sx={{ p: 2 }}
              variant='contained'
              color='inherit'
              size='large'
              disableElevation
              onClick={() => {
                navigate('/')
              }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default EmployeeIExitInterviewForm
